var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.41 17.41"}},[_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M17.41 1.41L16 0 8.71 7.29 1.41 0 0 1.41l7.29 7.3L0 16l1.41 1.41 7.3-7.29L16 17.41 17.41 16l-7.29-7.29 7.29-7.3z","data-name":"Layer 1-2"}})])])])])};var toString = function () {return "/opt/build/repo/src/assets/close.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = f71c
// module chunks = 0